module.exports = __webpack_public_path__ + "media/images/rank/bronze-md-68aba7a8b784d150e94a234f1ef3f3a8.svg";